/**
 * Brand product grid (sections/product-grid.liquid, when a "Brand (vendor)" is set).
 * Liquid can only loop over the first 50 products of a collection, so a brand whose products sit further
 * down the catalog showed nothing. This asks the Shop Products page for that brand (it filters on the whole
 * catalog), copies the first few product cards into the grid, and hides the "on the way" message.
 */
class VendorProducts extends HTMLElement {
  async connectedCallback() {
    const limit = parseInt(this.dataset.limit, 10) || 8;
    try {
      const response = await fetch(this.dataset.url, { headers: { 'X-Requested-With': 'fetch' } });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = [...doc.querySelectorAll('.catalog__grid > li')].slice(0, limit);
      if (!items.length) return;

      let list = this.querySelector('.product-grid__list');
      if (!list) {
        list = document.createElement('ul');
        list.className = 'product-grid__list';
        list.setAttribute('role', 'list');
        this.prepend(list);
      }
      list.replaceChildren();
      items.forEach((item) => {
        const li = document.importNode(item, true);
        // Match the brand page's cards: no SKU line, and the vendor only when the section shows it.
        li.querySelector('.product-card__sku')?.remove();
        if (this.dataset.showVendor !== 'true') li.querySelector('.product-card__vendor')?.remove();
        list.appendChild(li);
      });
      this.querySelector('.product-grid__empty')?.setAttribute('hidden', '');
    } catch (error) {
      // Leave whatever the page rendered.
    }
  }
}
if (!customElements.get('vendor-products')) customElements.define('vendor-products', VendorProducts);
